import { Space, Layout, Row, Col } from "antd";
import Image from "next/image";
import { useIntl, defineMessages } from "react-intl";

import { Head } from "../../../layouts/Head";
import { useIsDark } from "../../../lib/hooks/theme";
import welcomeImage from "../../../public/images/welcome-bg.png";
import { LanguageMenu } from "../../navigation/TopMenu/LanguageMenu";
import { Logo } from "../../shared/Logo";

const { Header, Content } = Layout;

const messages = defineMessages({
  pageTitle: { id: "user.signUp.title", defaultMessage: "Welcome" },
});

export default function SignUpLayout(props: { children: React.ReactNode }) {
  const intl = useIntl();
  const isDark = useIsDark();

  return (
    <>
      <Head title={intl.formatMessage(messages.pageTitle)} />

      <Layout>
        <Header style={{ justifyContent: "end" }}>
          <LanguageMenu />
        </Header>

        <Content>
          <Row style={{ minHeight: "calc(100vh - 50px)" }}>
            <Col
              style={{
                width: "100%",
                height: "calc(100vh - 50px)",
              }}
              span={0}
              lg={12}
            >
              <Image
                alt={intl.formatMessage(messages.pageTitle)}
                src={welcomeImage}
                fill
                quality={85}
                loading="lazy"
                placeholder="blur"
                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAIAAAC6ZnJRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAu0lEQVR4nAGwAE//ACgoKSUlKiEmLxAeKgUcKAAcLAAXJgAnKScSFB0AARkABRUKGS4aKEkAGC0AEBUhTFJge32JZXR6qLa+wMPNESQ3ACk0Rert8P///+/19svo68DI1hojPAAcKj/O0tzt8fjp6uTv7+vX1dsmLUkAAAMfESU3KTtQLTpUMTtVECA8AAArAAAOJgAHIQAJIAAKJQAAJQADKQAHLQAADykADyYAEiUAECkAAyYABCcACifz3zCprWqYvgAAAABJRU5ErkJggg=="
                sizes="(min-width: 992px) 50vw, 0vw"
                style={{
                  objectFit: "cover",
                }}
              />
            </Col>

            <Col span={24} lg={12} style={{ alignSelf: "center" }}>
              <Space
                orientation="vertical"
                size="large"
                style={{
                  maxWidth: "485px",
                  display: "flex",
                  margin: "auto",
                  padding: "0 20px",
                }}
              >
                <div style={{ textAlign: "center", marginBottom: 45 }}>
                  <Logo style={isDark ? "white" : "dark"} size="medium" />
                </div>

                {props.children}
              </Space>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
}
